import { render, staticRenderFns } from "./UserNavigationItem.vue?vue&type=template&id=e50b641e&scoped=true"
import script from "./UserNavigationItem.vue?vue&type=script&lang=js"
export * from "./UserNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./UserNavigationItem.vue?vue&type=style&index=0&id=e50b641e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50b641e",
  null
  
)

export default component.exports